module.exports = __webpack_public_path__ + "img/linea-atencion.e41add74.svg";